/*!

=========================================================
* Paper Kit PRO React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-pro-react
* Copyright 2020 Creative Tim (http://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/

import React, { useState, useEffect } from "react";
import {
  BrowserRouter,
  Route,
  Switch,
  Redirect,
  // useHistory,
} from "react-router-dom";

// styles
import "assets/css/bootstrap.min.css";
import "assets/scss/paper-kit.scss";
import "assets/demo/demo.css";
import "assets/demo/react-demo.css";
// pages
import Landing from "./pages/Landing.js";
import Login from "./pages/Login.js";
import Portfolio from "./pages/Portfolio/Index";
import EventCategoryPage from "./pages/Portfolio/EventCategoryPage";
import AboutUs from "./pages/AboutUs";
import Team from "./pages/Team";
import Faq from "./pages/FAQ";
import HealthAndSafety from "./pages/HealthAndSafety.js";
import AdminEvents from "./pages/Admin/AdminEvents";
import AdminEventCategories from "./pages/Admin/AdminEventCategories";
import ClientsPage from "./pages/ClientsPage";
import Logout from "./pages/Logout.js";
import ContactUs from "./pages/ContactUs.js";
import FooterBlack from "./components/Footers/FooterBlack";
import AdminContactUs from "./pages/Admin/AdminContactUs";
import fb from "./fb"
import { LoadingScreen } from "components/MiscFunctions.js";
import ScrollToTop from "./components/ScrollToTop"

// others

function App() {
  const [user, setUser] = useState();

  // Show loading screen when the user useeffect is still fetching
  const [loadingFlag, setLoadingFlag] = useState(true)

  // run once, set listener to auth user state
  // useEffect(() => {
  //   // listener for auth state:
  //   // 1 - cancel db user listener
  //   // 2 - if non-null auth user,  start new db user listener

  //   let unsubscribe = () => { }; // initially, do nothing

  //   const findAndSetUser = (user) => {
  //     unsubscribe();
  //     if (user) {
  //       unsubscribe = db.Users.listenOne(setUser, user.uid);
  //     } else {
  //       setUser(null);
  //     }
  //   };

  //   const authUnsubscribe = fb.auth().onAuthStateChanged(findAndSetUser);

  //   return () => {
  //     authUnsubscribe();
  //     unsubscribe();
  //   };
  // }, []);

  useEffect(() => {
    fb.auth().onAuthStateChanged(setUser)
    user && setLoadingFlag(false)
  }, [user])

  return (
    <>
      {
        // On first load, user is undefined, until the useeffect above is finished,
        // Show loading screen
        !loadingFlag || user !== undefined ?
          <BrowserRouter>
            <ScrollToTop />
            <Switch>
              {/* <Route path="/" render={(props) => <Landing {...props} />} /> */}
              <Route path="/logout" render={(props) => <Logout {...props} />} />
              <Route
                exact path="/portfolio/:category/:name"
                render={(props) => <EventCategoryPage {...props} />}
              />
              <Route
                exact path="/portfolio"
                render={(props) => <Portfolio {...props} />}
              />
              <Route path="/OurTeam" render={(props) => <Team {...props} />} />
              <Route path="/AboutUs" render={(props) => <AboutUs {...props} />} />
              <Route
                path="/contact-us"
                render={(props) => <ContactUs {...props} />}
              />
              <Route
                path="/clients"
                render={(props) => <ClientsPage {...props} />}
              />
              <Route
                path="/admin/contactUs"
                render={(props) => <AdminContactUs {...props} />}
              />
              <Route path="/FAQ" render={(props) => <Faq {...props} />} />
              <Route path="/HealthAndSafety" render={(props) => <HealthAndSafety {...props} />} />
              <Route path="/login" render={(props) => <Login {...props} />} />
              <Route exact path="/" render={(props) => <Landing {...props} />} />
              {
                user &&
                <Route
                  path="/admin/eventCategories"
                  render={(props) => <AdminEventCategories {...props} />}
                />
              }
              {
                user &&
                <Route
                  path="/admin/events"
                  render={(props) => <AdminEvents {...props} />}
                />
              }
              <Route render={() => <Redirect to={{ pathname: "/" }} />} />
            </Switch>
            <FooterBlack />
          </BrowserRouter>
          :
          <LoadingScreen />
      }
    </>
  );
}

export default App;
